interface IdleWarningModalProps {
  secondsRemaining: number
  onStay: () => void
  onLogout: () => void
}

function fmt(secs: number): string {
  const m = Math.floor(secs / 60)
  const s = secs % 60
  if (m <= 0) return `${s}s`
  return `${m}:${String(s).padStart(2, '0')}`
}

export default function IdleWarningModal({ secondsRemaining, onStay, onLogout }: IdleWarningModalProps) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="idle-title"
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgb(13 21 32 / 0.55)',
        display: 'grid', placeItems: 'center', padding: '20px',
        fontFamily: "'Manrope', sans-serif",
      }}
    >
      <div style={{
        background: 'white', borderRadius: '18px', padding: '30px 32px',
        width: 'min(440px, 100%)', boxShadow: '0 20px 60px rgb(13 21 32 / 0.35)',
        display: 'flex', flexDirection: 'column', gap: '10px',
      }}>
        <div style={{ fontSize: '30px', lineHeight: 1 }}>⏳</div>
        <h2 id="idle-title" style={{ fontSize: '17px', fontWeight: 800, color: 'var(--c-ink)', margin: 0 }}>
          ¿Sigues ahí?
        </h2>
        <p style={{ fontSize: '13px', color: 'var(--c-ink-muted)', margin: 0, lineHeight: 1.55 }}>
          No detectamos actividad en tu sesión. Por seguridad, cerraremos tu acceso
          automáticamente en <b style={{ color: 'var(--c-ink)' }}>{fmt(secondsRemaining)}</b>.
        </p>
        <div style={{ display: 'flex', gap: '10px', marginTop: '18px', justifyContent: 'flex-end' }}>
          <button
            onClick={onLogout}
            style={{
              all: 'unset', cursor: 'pointer',
              background: 'var(--c-surface-faint)', color: 'var(--c-ink-soft)',
              fontWeight: 700, fontSize: '13px', padding: '10px 18px', borderRadius: '10px',
            }}
          >
            Cerrar sesión
          </button>
          <button
            onClick={onStay}
            style={{
              all: 'unset', cursor: 'pointer',
              background: 'var(--c-brand)', color: 'white',
              fontWeight: 700, fontSize: '13px', padding: '10px 20px', borderRadius: '10px',
            }}
          >
            Sigo aquí
          </button>
        </div>
      </div>
    </div>
  )
}
